import type { IconSvgObject } from './types';

const DressingTable02Icon: IconSvgObject = [
  ["path", { d: "M5 16C4.5 16.3333 3.7 17.4 4.5 19C5.5 21 4 22 4 22M5 16V13M5 16H19M5 13H4M5 13H19M19 16C19.5 16.3333 20.3 17.4 19.5 19C18.5 21 20 22 20 22M19 16V13M19 13H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 7.5C7 10.5376 9.23857 13 12 13C14.7614 13 17 10.5376 17 7.5C17 4.46243 14.7614 2 12 2C9.23858 2 7 4.46243 7 7.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10.999 7L12.499 5.5M11.499 9.5L12.999 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default DressingTable02Icon;
